module.exports = __webpack_public_path__ + "assets/f59c7e7414880fe972a8f771e00efaed.mp3";